import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BookkeepingPage from './pages/BookkeepingPage';
import AuditAssurancePage from './pages/AuditAssurancePage';
import IndiaEntryPage from './pages/IndiaEntryPage';
import TaxPreparationPage from './pages/TaxPreparationPage';
import PricingPage from './pages/PricingPage';
import OurTeamPage from './pages/OurTeamPage';
import ServicesPage from './pages/ServicesPage';
import CommunityPage from './pages/CommunityPage';
import BookkeepingBlogPost from './pages/BookkeepingBlogPost';
import IncorporationBlogPost from './pages/IncorporationBlogPost';
import TaxObligationsBlogPost from './pages/TaxObligationsBlogPost';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Test backend connection
    const testBackend = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data);
      } catch (error) {
        console.error('Backend connection error:', error);
      }
    };
    testBackend();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bookkeeping" element={<BookkeepingPage />} />
          <Route path="/audit-assurance" element={<AuditAssurancePage />} />
          <Route path="/india-entry" element={<IndiaEntryPage />} />
          <Route path="/tax-preparation" element={<TaxPreparationPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/our-team" element={<OurTeamPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/blog/bookkeeping-best-practices" element={<BookkeepingBlogPost />} />
          <Route path="/blog/us-incorporation-checklist" element={<IncorporationBlogPost />} />
          <Route path="/blog/us-tax-obligations-foreign-startups" element={<TaxObligationsBlogPost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;